
export const reset = {
    title: "XOPYC–HORUS: Proizvodnja i prodaja odeće vrhunskog kvaliteta",
    description: "XOPYC–HORUS: Proizvodnja i prodaja odeće vrhunskog kvaliteta",
    keywords: "XOPYC–HORUS: Proizvodnja i prodaja odeće vrhunskog kvaliteta",
    logo: "https://horus.rs/logo512.png"
}